module.exports = __webpack_public_path__ + "static/media/B46186-RECEIV_1.44f3ed0b.PDF";